var _defs, _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgCounterRightArrow(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 30.561,
    height: 56.849,
    viewBox: "0 0 30.561 56.849",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_356",
    "data-name": "Rectangle 356",
    width: 56.849,
    height: 30.56,
    fill: "#fc6405"
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_120",
    "data-name": "Group 120",
    transform: "translate(30.561) rotate(90)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_32",
    "data-name": "Group 32",
    clipPath: "url(#clip-path)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_69",
    "data-name": "Path 69",
    d: "M54.035,11.559a22.429,22.429,0,0,1-5.017.026q.749-.906,1.518-1.793a74.917,74.917,0,0,1-7.824-4.684,97.536,97.536,0,0,0-9.487,12.733q-1.414,2.259-2.7,4.59-1.023-.062-2.1-.062t-2.1.062q-1.29-2.33-2.7-4.59A97.537,97.537,0,0,0,14.138,5.109,74.916,74.916,0,0,1,6.314,9.793q.768.886,1.518,1.793a22.423,22.423,0,0,1-5.017-.026q-.445-.5-.9-.99L0,8.476,2.48,7.305A71.136,71.136,0,0,0,13.416.876L14.643,0,15.68,1.138a101.388,101.388,0,0,1,12,16.186q.376.626.741,1.257.365-.631.74-1.257a101.431,101.431,0,0,1,12-16.186L42.206,0l1.228.876A71.136,71.136,0,0,0,54.37,7.305l2.479,1.171L54.93,10.569q-.451.491-.9.99",
    transform: "translate(0 8.129)",
    fill: " #D2D4C2"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_70",
    "data-name": "Path 70",
    d: "M0,13.254C3.654,6.6,5.879,3.571,6.085,0c.208,3.571,2.432,6.6,6.085,13.254q-1.283,1.477-2.459,3.062A25.8,25.8,0,0,1,6.085,8.143a25.819,25.819,0,0,1-3.626,8.173Q1.284,14.733,0,13.254",
    transform: "translate(22.339 0)",
    fill: " #D2D4C2"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCounterRightArrow);
export default __webpack_public_path__ + "static/media/counter-right-arrow.a4326eae34446761d4b935eced60f894.svg";
export { ForwardRef as ReactComponent };